import { nextId, nextIdWithReplacement } from '../../utils';
import reviewTicketApi from './graphql/ticketReviewApi';
import approveJobApi from './graphql/jobApproveApi';
import { getCurrentTicketId, getCurrentJobId, getCurrentDistrictId, getCurrentDepartmentId } from './selectors';
import { getUserDefaultDistrictId, getUserDefaultDepartmentId } from '../authentication/selectors';
import { jobUnreviewApi } from './graphql/jobUnreviewApi';

export const types = {
  SELECT_JOB_ID: 'jobApprovals/SELECT_JOB_ID',
  SELECT_TICKET_ID: 'jobApprovals/SELECT_TICKET_ID',
  SELECT_DISTRICT_ID: 'jobApprovals/SELECT_DISTRICT_ID',
  SELECT_DEPARTMENT_ID: 'jobApprovals/SELECT_DEPARTMENT_ID',
};


export const selectDistrictId = (districtId) => {
  return {
    type: types.SELECT_DISTRICT_ID,
    currentDistrictId: districtId,
  };
};


export const selectDepartmentId = (departmentId) => {
  return {
    type: types.SELECT_DEPARTMENT_ID,
    currentDepartmentId: departmentId,
  };
};


export const selectDistrict = (district) => {
  return selectDistrictId(district.id);
};


export const selectDepartment = (department) => {
  return selectDepartmentId(department.id);
};


export const selectJobId = (jobId) => {
  return {
    type: types.SELECT_JOB_ID,
    currentJobId: jobId,
  };
};


export const selectTicketId = (ticketId) => {
  return {
    type: types.SELECT_TICKET_ID,
    currentTicketId: ticketId,
  };
};


export const initPage = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const userDefaultDistrict = getUserDefaultDistrictId(state);
    const userDefaultDepartment = getUserDefaultDepartmentId(state);
    dispatch(selectJobId(null));
    dispatch(selectDistrictId(userDefaultDistrict));
    dispatch(selectDepartmentId(userDefaultDepartment));
  };
};


export const reviewTicketId = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const jobId = getCurrentJobId(state);
    const ticketId = getCurrentTicketId(state);
    const { oldCollection } = await reviewTicketApi(client, jobId, ticketId);
    const nextTicketId = nextIdWithReplacement(oldCollection, ticketId);
    dispatch(selectTicketId(nextTicketId));
  };
};


export const approveJobId = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const jobId = getCurrentJobId(state);
    const currentDistrictId = getCurrentDistrictId(state);
    const currentDepartmentId = getCurrentDepartmentId(state);
    const {
      oldCollection,
    } = await approveJobApi(client, jobId, { currentDistrictId, currentDepartmentId });
    const nextJobId = nextId(oldCollection, jobId);
    dispatch(selectJobId(nextJobId));
  };
};

export const unreviewJobId = (jobId, reason) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const currentDistrictId = getCurrentDistrictId(state);
    const currentDepartmentId = getCurrentDepartmentId(state);
    const { oldCollection } = await jobUnreviewApi(client, jobId, reason, { currentDistrictId, currentDepartmentId });
    const nextJobId = nextId(oldCollection, jobId);
    dispatch(selectJobId(nextJobId));
  };
};
